/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "body_prose_size_default": "prose-p:!mt-0",
  "body_prose_size_alternative": "prose-coverbox sm:prose-coverbox",
  "body_prose_colors_default": "",
  "body_prose_variant_default": "",
  "body_prose_variant_alternative": "",
  "body_size_default": "",
  "body_size_alternative": "",
  "body_colors_default": "",
  "body_variant_default": "relative group desktop:line-clamp-none data-[expanded=\"true\"]:!line-clamp-none",
  "body_variant_alternative": "relative group desktop:line-clamp-none data-[expanded=\"true\"]:!line-clamp-none",
  "group_size_default": "gap-1",
  "group_size_alternative": "gap-0.5 md:gap-1.5 max-w-[720px]",
  "group_colors_default": "",
  "group_variant_default": "flex flex-col",
  "group_variant_alternative": "flex flex-col items-start grow",
  "expand_size_default": "text-body-sm font-bold",
  "expand_size_alternative": "text-mb-headline-2xs",
  "expand_colors_default": "bg-mb-cherry-blossom-200",
  "expand_variant_default": "absolute bottom-0 right-0 font-primary cursor-pointer hover:underline group-data-[clamped=\"false\"]:hidden",
  "expand_variant_alternative": "absolute bottom-0 right-0 font-primary cursor-pointer hover:underline group-data-[clamped=\"false\"]:hidden",
  "headline_size_default": "text-headline",
  "headline_size_alternative": "text-mb-headline md:text-mb-headline-2xl",
  "headline_colors_default": "text-black",
  "headline_variant_default": "capitalize",
  "headline_variant_alternative": "capitalize",
  "icon_size_default": "",
  "icon_size_alternative": "[&_svg]:w-[70px] [&_svg]:h-[70px]",
  "icon_colors_default": "",
  "icon_variant_default": "",
  "icon_variant_alternative": "",
  "images_size_default": "",
  "images_size_salternative": "",
  "images_colors_default": "",
  "images_variant_default": "",
  "images_variant_alternative": "",
  "size_default": "w-full gap-1 p-3 sm:p-6",
  "size_alternative": "w-full gap-6 py-3 md:py-6",
  "colors_default": "bg-mb-cherry-blossom-200 wings-mb-cherry-blossom-200",
  "variant_default": "flex flex-col",
  "variant_alternative": "flex flex-row-reverse md:flex-row rounded wings",
  "expand_colors_feelgood": "bg-mb-clementine-200",
  "expand_colors_halsa": "bg-mb-cherry-blossom-200",
  "expand_colors_medicin": "bg-mb-eastern-blue-200",
  "expand_colors_modeOchSkonhet": "bg-mb-cannon-pink-200",
  "expand_colors_nyttigMat": "bg-mb-emerald-200",
  "expand_colors_psykologi": "bg-mb-elm-500",
  "expand_colors_relationer": "bg-mb-orpiment-200",
  "expand_colors_reportage": "bg-mb-cherry-blossom-200",
  "expand_colors_resor": "bg-mb-cherry-blossom-200",
  "expand_colors_senasteNytt": "bg-mb-cinnabar-200",
  "expand_colors_traning": "bg-mb-yellow-sea-300",
  "expand_colors_vikt": "bg-mb-cherry-blossom-200",
  "group_colors_feelgood": "",
  "group_colors_halsa": "",
  "group_colors_medicin": "",
  "group_colors_modeOchSkonhet": "",
  "group_colors_nyttigMat": "",
  "group_colors_psykologi": "",
  "group_colors_relationer": "",
  "group_colors_reportage": "",
  "group_colors_resor": "",
  "group_colors_senasteNytt": "",
  "group_colors_traning": "",
  "group_colors_vikt": "",
  "icon_colors_feelgood": "",
  "icon_colors_halsa": "",
  "icon_colors_medicin": "",
  "icon_colors_modeOchSkonhet": "",
  "icon_colors_nyttigMat": "",
  "icon_colors_psykologi": "",
  "icon_colors_relationer": "",
  "icon_colors_reportage": "",
  "icon_colors_resor": "",
  "icon_colors_senasteNytt": "",
  "icon_colors_traning": "",
  "icon_colors_vikt": "",
  "headline_colors_feelgood": "",
  "headline_colors_halsa": "",
  "headline_colors_medicin": "",
  "headline_colors_modeOchSkonhet": "",
  "headline_colors_nyttigMat": "",
  "headline_colors_psykologi": "",
  "headline_colors_relationer": "",
  "headline_colors_reportage": "",
  "headline_colors_resor": "",
  "headline_colors_senasteNytt": "",
  "headline_colors_traning": "",
  "headline_colors_vikt": "",
  "body_prose_colors_feelgood": "",
  "body_prose_colors_halsa": "",
  "body_prose_colors_medicin": "",
  "body_prose_colors_modeOchSkonhet": "",
  "body_prose_colors_nyttigMat": "",
  "body_prose_colors_psykologi": "",
  "body_prose_colors_relationer": "",
  "body_prose_colors_reportage": "",
  "body_prose_colors_resor": "",
  "body_prose_colors_senasteNytt": "",
  "body_prose_colors_traning": "",
  "body_prose_colors_vikt": "",
  "body_colors_feelgood": "",
  "body_colors_halsa": "",
  "body_colors_medicin": "",
  "body_colors_modeOchSkonhet": "",
  "body_colors_nyttigMat": "",
  "body_colors_psykologi": "",
  "body_colors_relationer": "",
  "body_colors_reportage": "",
  "body_colors_resor": "",
  "body_colors_senasteNytt": "",
  "body_colors_traning": "",
  "body_colors_vikt": "",
  "images_colors_feelgood": "",
  "images_colors_halsa": "",
  "images_colors_medicin": "",
  "images_colors_modeOchSkonhet": "",
  "images_colors_nyttigMat": "",
  "images_colors_psykologi": "",
  "images_colors_relationer": "",
  "images_colors_reportage": "",
  "images_colors_resor": "",
  "images_colors_senasteNytt": "",
  "images_colors_traning": "",
  "images_colors_vikt": "",
  "colors_feelgood": "bg-mb-clementine-200 wings-mb-clementine-200",
  "colors_halsa": "bg-mb-cherry-blossom-200 wings-mb-cherry-blossom-200",
  "colors_medicin": "bg-mb-eastern-blue-200 wings-mb-eastern-blue-200",
  "colors_modeOchSkonhet": "bg-mb-cannon-pink-200 wings-mb-cannon-pink-200",
  "colors_nyttigMat": "bg-mb-emerald-200 wings-mb-emerald-200",
  "colors_psykologi": "bg-mb-elm-500 wings-mb-elm-500",
  "colors_relationer": "bg-mb-orpiment-200 wings-mb-orpiment-200",
  "colors_reportage": "bg-mb-cherry-blossom-200 wings-mb-cherry-blossom-200",
  "colors_resor": "bg-mb-cherry-blossom-200 wings-mb-cherry-blossom-200",
  "colors_senasteNytt": "bg-mb-cinnabar-200 wings-mb-cinnabar-200",
  "colors_traning": "bg-mb-yellow-sea-300 wings-mb-yellow-sea-300",
  "colors_vikt": "bg-mb-cherry-blossom-200 wings-mb-cherry-blossom-200"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "CoverBox");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;